import React, { useEffect } from 'react'
import useMediaQuery from '../../../utils/useMediaQuery'
import { LeftSide } from './left-side'
import { RightSide } from './right-side'

export default function TopSectionContent({ ready }) {
  const isMobile = useMediaQuery()
  return (
    <div className="f-top-section__wrapper">
      <LeftSide isMobile={isMobile} ready={ready} />
      <aside className="f-top-section__side">
        <RightSide isMobile={isMobile} topWinners={[]} ready={ready} />
      </aside>
    </div>
  )
}
